module.exports = __webpack_public_path__ + "static/media/gpg.81fd2f8a.png";